import { POSTER_PAGE, type PosterDoc, type PosterQrElement } from "@studio/shared";
import { QR_MIN_MM } from "./geometry";

/**
 * 포스터 QR 은 학생이 놓지 않는다 — 그리는 쪽이 오른쪽 아래 구석에 자동으로 붙인다(2026-10-04 jery).
 *
 * 🔑 편집 화면에는 QR 이 없다(문서에도 저장하지 않는다). 노래·AR 미리보기·확정·PDF/PNG·반 묶음처럼
 *    «QR 주소를 넘겨받은» 렌더만 이 자리에 QR 을 그린다. 그래서 한 곳(이 파일)만 고치면 전부 같이 바뀐다.
 * 🔑 옛 문서에 남아 있는 QR 요소는 무시한다 — 안 그러면 QR 이 두 개 찍힌다.
 * 🚨 인쇄 3cm 아래로 내려가면 폰이 못 읽는다(QR_MIN_MM).
 */
const SIZE_MM = 32;
const MARGIN_MM = 8;

export const AUTO_QR: PosterQrElement = {
  id: "auto-qr",
  type: "qr",
  x: POSTER_PAGE.width - MARGIN_MM - SIZE_MM,
  y: POSTER_PAGE.height - MARGIN_MM - SIZE_MM,
  w: Math.max(QR_MIN_MM, SIZE_MM),
  h: Math.max(QR_MIN_MM, SIZE_MM),
  rot: 0,
  opacity: 1,
};

export function withoutQr(doc: PosterDoc): PosterDoc {
  return doc.els.some((element) => element.type === "qr") ? { ...doc, els: doc.els.filter((element) => element.type !== "qr") } : doc;
}

/** QR 을 맨 위(맨 앞)에 붙인다 — 그림·도형에 가려지면 못 읽는다. */
export function withAutoQr(doc: PosterDoc): PosterDoc {
  return { ...doc, els: [...withoutQr(doc).els, AUTO_QR] };
}

/** 바이트로 그릴 문서 — QR 주소가 있으면 구석 QR 을 붙이고, 없으면 QR 없이. */
export function docForRender(input: { doc: PosterDoc; qrUrl: string | null }): PosterDoc {
  return input.qrUrl ? withAutoQr(input.doc) : withoutQr(input.doc);
}
